import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Auth0Provider } from "@auth0/auth0-react" 


ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider domain={"dev-6g4ym8b4.us.auth0.com"} clientId={"2BL6EQ58djTfb3Ta4Og9AKSuwWSqVssE"} redirectUri={window.location.href}>
      <App/>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
